(() => {
  const STORAGE_REGION_KEY = 'region';
  const STORAGE_COMUNA_KEY = 'comuna';
  const SELECT_REGION_PLACEHOLDER = 'Selecciona tu región';
  const SELECT_COMUNA_PLACEHOLDER = 'Selecciona tu comuna';

  const REGION_NAMES = {
    AP: 'Arica y Parinacota',
    TA: 'Tarapacá',
    AN: 'Antofagasta',
    AT: 'Atacama',
    CO: 'Coquimbo',
    VS: 'Valparaíso',
    RM: 'Región Metropolitana',
    LI: "O'Higgins",
    ML: 'Maule',
    NB: 'Ñuble',
    BI: 'Biobio',
    AR: 'Araucanía',
    LR: 'Los Ríos',
    LL: 'Los Lagos',
    AI: 'Aysén',
    MA: 'Magallanes'
  };

  const REGION_TOWNS = {
    AN: [
      'Antofagasta',
      'Calama',
      'María Elena',
      'Mejillones',
      'Ollagüe',
      'San Pedro de Atacama',
      'Sierra Gorda',
      'Taltal',
      'Tocopilla'
    ],
    AR: [
      'Angol',
      'Carahue',
      'Cholchol',
      'Collipulli',
      'Cunco',
      'Curacautín',
      'Curarrehue',
      'Ercilla',
      'Freire',
      'Galvarino',
      'Gorbea',
      'Lautaro',
      'Loncoche',
      'Lonquimay',
      'Los Sauces',
      'Lumaco',
      'Melipeuco',
      'Nueva Imperial',
      'Padre las Casas',
      'Perquenco',
      'Pitrufquén',
      'Pucón',
      'Purén',
      'Renaico',
      'Saavedra',
      'Temuco',
      'Teodoro Schmidt',
      'Toltén',
      'Traiguén',
      'Victoria',
      'Vilcún',
      'Villarrica'
    ],
    AP: ['Arica', 'Camarones', 'General Lagos', 'Putre'],
    AT: [
      'Alto del Carmen',
      'Caldera',
      'Chañaral',
      'Copiapó',
      'Diego de Almagro',
      'Freirina',
      'Huasco',
      'Tierra Amarilla',
      'Vallenar'
    ],
    AI: [
      'Aisén',
      'Chile Chico',
      'Cisnes',
      'Cochrane',
      'Coihaique',
      'Guaitecas',
      'Lago Verde',
      'O’Higgins',
      'Río Ibáñez',
      'Tortel'
    ],
    BI: [
      'Alto Biobío',
      'Antuco',
      'Arauco',
      'Cabrero',
      'Cañete',
      'Chiguayante',
      'Concepción',
      'Contulmo',
      'Coronel',
      'Curanilahue',
      'Florida',
      'Hualpén',
      'Hualqui',
      'Laja',
      'Lebu',
      'Los Álamos',
      'Los Ángeles',
      'Lota',
      'Mulchén',
      'Nacimiento',
      'Negrete',
      'Penco',
      'Quilaco',
      'Quilleco',
      'San Pedro de la Paz',
      'San Rosendo',
      'Santa Bárbara',
      'Santa Juana',
      'Talcahuano',
      'Tirúa',
      'Tomé',
      'Tucapel',
      'Yumbel'
    ],
    CO: [
      'Andacollo',
      'Canela',
      'Combarbalá',
      'Coquimbo',
      'Illapel',
      'La Higuera',
      'La Serena',
      'Los Vilos',
      'Monte Patria',
      'Ovalle',
      'Paihuano',
      'Punitaqui',
      'Río Hurtado',
      'Salamanca',
      'Vicuña'
    ],
    LL: [
      'Ancud',
      'Calbuco',
      'Castro',
      'Chaitén',
      'Chonchi',
      'Cochamó',
      'Curaco de Vélez',
      'Dalcahue',
      'Fresia',
      'Frutillar',
      'Futaleufú',
      'Hualaihué',
      'Llanquihue',
      'Los Muermos',
      'Maullín',
      'Osorno',
      'Palena',
      'Puerto Montt',
      'Puerto Octay',
      'Puerto Varas',
      'Puqueldón',
      'Purranque',
      'Puyehue',
      'Queilén',
      'Quellón',
      'Quemchi',
      'Quinchao',
      'Río Negro',
      'San Juan de la Costa',
      'San Pablo'
    ],
    LR: [
      'Corral',
      'Futrono',
      'La Unión',
      'Lago Ranco',
      'Lanco',
      'Los Lagos',
      'Mariquina',
      'Máfil',
      'Paillaco',
      'Panguipulli',
      'Río Bueno',
      'Valdivia'
    ],
    MA: [
      'Antártica',
      'Cabo de Hornos (Ex Navarino)',
      'Laguna Blanca',
      'Natales',
      'Porvenir',
      'Primavera',
      'Punta Arenas',
      'Río Verde',
      'San Gregorio',
      'Timaukel',
      'Torres del Paine'
    ],
    ML: [
      'Cauquenes',
      'Chanco',
      'Colbún',
      'Constitución',
      'Curepto',
      'Curicó',
      'Empedrado',
      'Hualañé',
      'Licantén',
      'Linares',
      'Longaví',
      'Maule',
      'Molina',
      'Parral',
      'Pelarco',
      'Pelluhue',
      'Pencahue',
      'Rauco',
      'Retiro',
      'Romeral',
      'Río Claro',
      'Sagrada Familia',
      'San Clemente',
      'San Javier',
      'San Rafael',
      'Talca',
      'Teno',
      'Vichuquén',
      'Villa Alegre',
      'Yerbas Buenas'
    ],
    NB: [
      'Bulnes',
      'Chillán',
      'Chillán Viejo',
      'Cobquecura',
      'Coelemu',
      'Coihueco',
      'El Carmen',
      'Ninhue',
      'Pemuco',
      'Pinto',
      'Portezuelo',
      'Quillón',
      'Quirihue',
      'Ránquil',
      'San Carlos',
      'San Fabián',
      'San Ignacio',
      'San Nicolás',
      'Treguaco',
      'Yungay',
      'Ñiquén'
    ],
    LI: [
      'Chimbarongo',
      'Chépica',
      'Codegua',
      'Coinco',
      'Coltauco',
      'Doñihue',
      'Graneros',
      'La Estrella',
      'Las Cabras',
      'Litueche',
      'Lolol',
      'Machalí',
      'Malloa',
      'Marchihue',
      'Mostazal',
      'Nancagua',
      'Navidad',
      'Olivar',
      'Palmilla',
      'Paredones',
      'Peralillo',
      'Peumo',
      'Pichidegua',
      'Pichilemu',
      'Placilla',
      'Pumanque',
      'Quinta de Tilcoco',
      'Rancagua',
      'Rengo',
      'Requínoa',
      'San Fernando',
      'San Vicente',
      'Santa Cruz'
    ],
    RM: [
      'Alhué',
      'Buin',
      'Calera de Tango',
      'Cerrillos',
      'Cerro Navia',
      'Colina',
      'Conchalí',
      'Curacaví',
      'El Bosque',
      'El Monte',
      'Estación Central',
      'Huechuraba',
      'Independencia',
      'Isla de Maipo',
      'La Cisterna',
      'La Florida',
      'La Granja',
      'La Pintana',
      'La Reina',
      'Lampa',
      'Las Condes',
      'Lo Barnechea',
      'Lo Espejo',
      'Lo Prado',
      'Macul',
      'Maipú',
      'María Pinto',
      'Melipilla',
      'Ñuñoa',
      'Padre Hurtado',
      'Paine',
      'Pedro Aguirre Cerda',
      'Peñaflor',
      'Peñalolén',
      'Pirque',
      'Providencia',
      'Pudahuel',
      'Puente Alto',
      'Quilicura',
      'Quinta Normal',
      'Recoleta',
      'Renca',
      'San Bernardo',
      'San Joaquín',
      'San José de Maipo',
      'San Miguel',
      'San Pedro',
      'San Ramón',
      'Santiago',
      'Talagante',
      'Tiltil',
      'Vitacura'
    ],
    TA: ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'],
    VS: [
      'Algarrobo',
      'Cabildo',
      'Calera',
      'Calle Larga',
      'Cartagena',
      'Casablanca',
      'Catemu',
      'Concón',
      'El Quisco',
      'El Tabo',
      'Hijuelas',
      'Isla de Pascua',
      'Juan Fernández',
      'La Cruz',
      'La Ligua',
      'Limache',
      'Llaillay',
      'Los Andes',
      'Nogales',
      'Olmué',
      'Panquehue',
      'Papudo',
      'Petorca',
      'Puchuncaví',
      'Putaendo',
      'Quillota',
      'Quilpué',
      'Quintero',
      'Rinconada',
      'San Antonio',
      'San Esteban',
      'San Felipe',
      'Santa María',
      'Santo Domingo',
      'Valparaíso',
      'Villa Alemana',
      'Viña del Mar',
      'Zapallar'
    ]
  };

  function parseExcludedRegions(rawValue) {
    if (!rawValue || typeof rawValue !== 'string') return new Set();

    return new Set(
      rawValue
        .split(/[\n,;]+/)
        .map((value) => value.trim().toUpperCase())
        .filter(Boolean)
    );
  }

  function normalizeTownName(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function parseExcludedTowns(rawValue) {
    const excludedByRegion = new Map();
    if (!rawValue || typeof rawValue !== 'string') return excludedByRegion;

    rawValue.split(/\r?\n/).forEach((line) => {
      const entry = line.trim();
      if (!entry) return;

      const separatorIndex = entry.indexOf(':');
      if (separatorIndex === -1) return;

      const regionCode = entry.slice(0, separatorIndex).trim().toUpperCase();
      const townName = normalizeTownName(entry.slice(separatorIndex + 1));
      if (!regionCode || !townName) return;

      if (!excludedByRegion.has(regionCode)) {
        excludedByRegion.set(regionCode, new Set());
      }

      excludedByRegion.get(regionCode).add(townName);
    });

    return excludedByRegion;
  }

  function buildAvailableLocationData() {
    const config = window.NutriscoComunaConfig || {};
    const excludedRegions = parseExcludedRegions(config.excludedRegions);
    const excludedTowns = parseExcludedTowns(config.excludedTowns);

    const regionNames = {};
    const regionTowns = {};

    Object.keys(REGION_NAMES).forEach((regionCode) => {
      if (excludedRegions.has(regionCode)) return;

      const towns = (REGION_TOWNS[regionCode] || []).filter((town) => {
        const excludedTownsForRegion = excludedTowns.get(regionCode);
        if (!excludedTownsForRegion) return true;
        return !excludedTownsForRegion.has(normalizeTownName(town));
      });

      if (!towns.length) return;

      regionNames[regionCode] = REGION_NAMES[regionCode];
      regionTowns[regionCode] = towns;
    });

    return {
      regionNames,
      regionTowns
    };
  }

  const AVAILABLE_LOCATIONS = buildAvailableLocationData();
  const AVAILABLE_REGION_NAMES = AVAILABLE_LOCATIONS.regionNames;
  const AVAILABLE_REGION_TOWNS = AVAILABLE_LOCATIONS.regionTowns;

  function clearTownOptions(select) {
    select.innerHTML = `<option value="">${SELECT_COMUNA_PLACEHOLDER}</option>`;
  }

  function populateTownOptions(select, region) {
    clearTownOptions(select);
    if (!region || !AVAILABLE_REGION_TOWNS[region]) return;

    AVAILABLE_REGION_TOWNS[region].forEach((town) => {
      const option = document.createElement('option');
      option.value = town;
      option.textContent = town;
      select.appendChild(option);
    });
  }

  function populateCityOptions(select) {
    select.innerHTML = `<option value="">${SELECT_REGION_PLACEHOLDER}</option>`;

    Object.keys(AVAILABLE_REGION_NAMES).forEach((regionCode) => {
      const option = document.createElement('option');
      option.value = regionCode;
      option.textContent = AVAILABLE_REGION_NAMES[regionCode];
      select.appendChild(option);
    });
  }

  function setSelectValues(citySelect, townSelect, region, comuna) {
    if (region && AVAILABLE_REGION_NAMES[region]) {
      citySelect.value = region;
      populateTownOptions(townSelect, region);
    } else {
      citySelect.value = '';
      clearTownOptions(townSelect);
    }

    if (
      comuna &&
      citySelect.value &&
      AVAILABLE_REGION_TOWNS[citySelect.value] &&
      AVAILABLE_REGION_TOWNS[citySelect.value].includes(comuna)
    ) {
      townSelect.value = comuna;
    } else {
      townSelect.value = '';
    }

    return {
      region: citySelect.value,
      comuna: townSelect.value
    };
  }

  function getStoredValue(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setStoredValue(key, value) {
    try {
      if (value) {
        localStorage.setItem(key, value);
      } else {
        localStorage.removeItem(key);
      }
    } catch (error) {
      // no-op
    }
  }

  function setSelectedLabel(root, comuna) {
    const valueElement = root.querySelector('.js-header-comuna-value');
    const defaultLabel = root.dataset.defaultLabel || SELECT_COMUNA_PLACEHOLDER;
    if (!valueElement) return;

    valueElement.textContent = comuna || defaultLabel;
  }

  function closePanel(root) {
    const panel = root.querySelector('.header-comuna__panel');
    const toggle = root.querySelector('.header-comuna__toggle');
    if (!panel || !toggle) return;

    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function openPanel(root) {
    const panel = root.querySelector('.header-comuna__panel');
    const toggle = root.querySelector('.header-comuna__toggle');
    if (!panel || !toggle) return;

    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  function togglePanel(root) {
    const panel = root.querySelector('.header-comuna__panel');
    if (!panel) return;

    if (panel.hidden) {
      openPanel(root);
    } else {
      closePanel(root);
    }
  }

  function syncCartSelector(region, comuna) {
    const cartCitySelect = document.querySelector('.js-cart-select-city');
    const cartTownSelect = document.querySelector('.js-cart-select-town');
    if (!cartCitySelect || !cartTownSelect) return;

    const regionValue = region || '';
    const comunaValue = comuna || '';

    if (cartCitySelect.value !== regionValue) {
      cartCitySelect.value = regionValue;
      cartCitySelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (cartTownSelect.value !== comunaValue) {
      cartTownSelect.value = comunaValue;
      cartTownSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function broadcastSelection(region, comuna, source = 'header') {
    window.dispatchEvent(
      new CustomEvent('nutrisco:comuna-change', {
        detail: {
          region: region || '',
          comuna: comuna || '',
          source
        }
      })
    );
  }

  function applySelection(root, region, comuna, options = {}) {
    const { syncCart = false, emit = false, persist = true } = options;

    const citySelect = root.querySelector('.js-header-select-city');
    const townSelect = root.querySelector('.js-header-select-town');
    if (!citySelect || !townSelect) return;

    const selected = setSelectValues(citySelect, townSelect, region, comuna);
    const selectedRegion = selected.region;
    const selectedComuna = selected.comuna;

    if (persist) {
      setStoredValue(STORAGE_REGION_KEY, selectedRegion);
      setStoredValue(STORAGE_COMUNA_KEY, selectedComuna);
    }

    setSelectedLabel(root, selectedComuna);

    if (syncCart) {
      syncCartSelector(selectedRegion, selectedComuna);
    }

    if (emit) {
      broadcastSelection(selectedRegion, selectedComuna);
    }
  }

  function initSelector(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const toggle = root.querySelector('.header-comuna__toggle');
    const saveButton = root.querySelector('.js-header-comuna-save');
    const laterButton = root.querySelector('.js-header-comuna-later');
    const citySelect = root.querySelector('.js-header-select-city');
    const townSelect = root.querySelector('.js-header-select-town');

    if (!toggle || !saveButton || !laterButton || !citySelect || !townSelect) return;

    populateCityOptions(citySelect);
    clearTownOptions(townSelect);

    applySelection(root, getStoredValue(STORAGE_REGION_KEY), getStoredValue(STORAGE_COMUNA_KEY), {
      syncCart: false,
      emit: false,
      persist: false
    });

    toggle.addEventListener('click', () => {
      togglePanel(root);
    });

    saveButton.addEventListener('click', () => {
      closePanel(root);
    });

    laterButton.addEventListener('click', () => {
      closePanel(root);
    });

    citySelect.addEventListener('change', () => {
      applySelection(root, citySelect.value, '', {
        syncCart: true,
        emit: true,
        persist: true
      });
    });

    townSelect.addEventListener('change', () => {
      applySelection(root, citySelect.value, townSelect.value, {
        syncCart: true,
        emit: true,
        persist: true
      });
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) {
        closePanel(root);
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closePanel(root);
      }
    });

    window.addEventListener('nutrisco:comuna-change', (event) => {
      const detail = event.detail || {};
      if (detail.source === 'header') return;

      applySelection(root, detail.region, detail.comuna, {
        syncCart: false,
        emit: false,
        persist: false
      });
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== STORAGE_REGION_KEY && event.key !== STORAGE_COMUNA_KEY) return;

      applySelection(root, getStoredValue(STORAGE_REGION_KEY), getStoredValue(STORAGE_COMUNA_KEY), {
        syncCart: false,
        emit: false,
        persist: false
      });
    });

    root.dataset.initialized = 'true';
  }

  function setPopupVisibility(root, isVisible) {
    root.hidden = !isVisible;
    document.body.classList.toggle('comuna-popup-open', isVisible);
  }

  function initPopup(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const saveButton = root.querySelector('.js-popup-comuna-save');
    const citySelect = root.querySelector('.js-popup-select-city');
    const townSelect = root.querySelector('.js-popup-select-town');
    if (!saveButton || !citySelect || !townSelect) return;

    populateCityOptions(citySelect);
    clearTownOptions(townSelect);

    const syncFromStorage = (toggleVisibility = false) => {
      const selected = setSelectValues(
        citySelect,
        townSelect,
        getStoredValue(STORAGE_REGION_KEY),
        getStoredValue(STORAGE_COMUNA_KEY)
      );

      if (toggleVisibility) {
        setPopupVisibility(root, !selected.comuna);
      }
    };

    syncFromStorage(true);

    citySelect.addEventListener('change', () => {
      setSelectValues(citySelect, townSelect, citySelect.value, '');
      citySelect.classList.remove('is-invalid');
      townSelect.classList.remove('is-invalid');
    });

    townSelect.addEventListener('change', () => {
      if (townSelect.value) {
        townSelect.classList.remove('is-invalid');
      }
    });

    saveButton.addEventListener('click', () => {
      const selectedRegion = citySelect.value;
      const selectedComuna = townSelect.value;

      if (!selectedRegion || !selectedComuna) {
        citySelect.classList.toggle('is-invalid', !selectedRegion);
        townSelect.classList.toggle('is-invalid', !selectedComuna);
        return;
      }

      setStoredValue(STORAGE_REGION_KEY, selectedRegion);
      setStoredValue(STORAGE_COMUNA_KEY, selectedComuna);
      syncCartSelector(selectedRegion, selectedComuna);
      broadcastSelection(selectedRegion, selectedComuna, 'popup');
      setPopupVisibility(root, false);
    });

    window.addEventListener('nutrisco:comuna-change', (event) => {
      const detail = event.detail || {};
      if (detail.source === 'popup') return;

      const selected = setSelectValues(citySelect, townSelect, detail.region, detail.comuna);
      if (selected.comuna) {
        setPopupVisibility(root, false);
      }
    });

    window.addEventListener('storage', (event) => {
      if (event.key !== STORAGE_REGION_KEY && event.key !== STORAGE_COMUNA_KEY) return;
      syncFromStorage(false);
    });

    root.dataset.initialized = 'true';
  }

  function initAll(scope = document) {
    scope.querySelectorAll('.js-header-comuna-selector').forEach((root) => initSelector(root));
    scope.querySelectorAll('.js-comuna-popup').forEach((root) => initPopup(root));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
